const initState = { data: [] };
const remove = (tags, tag) => {
  const filtered = tags.filter((t) => t.objectId !== tag.objectId);
  return [...filtered];
};

const upsert = (tags, tag) => {
  return [...remove(tags, tag), tag];
};

const update = (tags, tag) => {
  const index = tags.findIndex((x) => x.objectId === tag.objectId);
  tags.splice(index, 1, tag);
  return [...tags];
};

export const tagsReducer = (tags = initState, action) => {
  let oldTags = tags.data;

  switch (action.actionType) {
    case 'tagsByBeaconId':
      return {
        data: action.payload,
      };

    case 'getLifeObject':
    case 'getTag':
      return {
        ...tags,
        data: action.payload,
      };

    case 'getMyLifeObjects':
    case 'getTags':
      return {
        data: Array.isArray(action.payload)
          ? action.payload.reverse()
          : action.payload,
      };

    case 'getTagsByBeaconId':
      return {
        data: action.payload.reverse(),
      };

    case 'deleteLifeObject':
    case 'deleteTag':
      return {
        ...tags,
        data: remove(oldTags, action.payload),
      };

    case 'updateLifeObject':
    case 'updateMyTag':
      return {
        ...tags,
        data: update(oldTags, action.payload),
      };

    case 'createLifeObject':
    case 'createTag':
      return {
        ...tags,
        data: upsert(oldTags, action.payload),
      };

    default:
      return tags;
  }
};
